import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { FcMoneyTransfer, FcOrgUnit, FcMenu ,FcPackage,FcManager} from "react-icons/fc"; 
import { BsCashStack} from "react-icons/bs";
import { FaUsersLine} from "react-icons/fa6";
import HandleCurrentPath from "./HandleCurrentPath";
import { TbPackages } from "react-icons/tb";
const MobileHamburger = () => {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const toggleSideMenu = () => {
    setIsSideMenuOpen(!isSideMenuOpen);

  }; 
    const closeSideMenu = () => {
        setIsSideMenuOpen(false);
    };
    const pathname = window.location.pathname;
  
  return (
    <>
     {/* Mobile menu */}

     <aside
                className={`fixed inset-y-0 z-20 flex-shrink-0 w-64 mt-16 overflow-y-auto bg-white dark:bg-gray-800 md:hidden ${isSideMenuOpen ? 'block' : 'hidden'}`}
                onClick={closeSideMenu}
            >
                <div className="py-4 text-gray-500 dark:text-gray-400">
          <Link
            className="ml-6 text-lg font-bold text-gray-800 dark:text-gray-200"
            href="#"
          >
           Pixi Travel
          </Link>
          <ul className="mt-6">
                <li className="relative px-6 py-3">
                 
                <HandleCurrentPath staticPath={'/'} currentPath={pathname} />
                <Link
                    className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/"}
                >
                    <FcOrgUnit />
                    <span className="ml-4">Dashboard</span>
                </Link>
                </li>
            </ul>
          <ul className="mt-6">
     



          <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/client'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/client'} >
                 <FaUsersLine/>
                <span className="ml-4">Client </span>
            </Link>
        </li>

        <li className="relative px-6 py-3">
          <HandleCurrentPath staticPath={'/maTravelPackage'} currentPath={pathname} />
          <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/maTravelPackage'} >
              <TbPackages/>
              <span className="ml-4">MaTravelPackage </span>
          </Link>
      </li>

      <li className="relative px-6 py-3">
        <HandleCurrentPath staticPath={'/mapackageitem'} currentPath={pathname} />
        <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/mapackageitem'} >
            <FcPackage/>
            <span className="ml-4">Mapackageitem </span>
        </Link>
      </li>

      <li className="relative px-6 py-3">
        <HandleCurrentPath staticPath={'/matravelpackageinclusion'} currentPath={pathname} />
        <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/matravelpackageinclusion'} >
            <FcManager/>
            <span className="ml-4">Matravelpackageinclusion </span>
        </Link>
      </li>

      <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/matravelpackageexclusion'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/matravelpackageexclusion'} >
                <FcManager/>
                <span className="ml-4">Matravel Package Exclusions </span>
            </Link>
        </li>

        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/invoices'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/invoices'} >
                <FcManager/>
                <span className="ml-4">Invoices </span>
            </Link>
        </li>

    </ul>
</div>

            </aside>
            {/* End mobile Menu */}
    <button
      className={`p-1 mr-5 -ml-1 rounded-md md:hidden focus:outline-none focus:shadow-outline-purple ${isSideMenuOpen ? 'bg-purple-500' : 'bg-transparent'}`}
      onClick={toggleSideMenu}
      aria-label="Menu"
    >

        <FcMenu/>
      {/* <svg
        className="w-6 h-6 text-white"
        aria-hidden="false"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
          clipRule="evenodd"
        />
      </svg> */}
    </button>
    </>
    
  );
};

export default MobileHamburger;